import { Typography } from '@mui/material'
import { ResponsivePie } from '@nivo/pie'

export type PieChartDataPoint = {
  id: string
  label?: string
  value: number
  color?: string
}

type Props = {
  dataPoints: PieChartDataPoint[]
  height?: number
  title?: string
}

export const PieChart = ({ dataPoints, height = 300, title }: Props) => {
  return (
    <section>
      {title && (
        <Typography variant="h6" component="h2" align="center">
          {title}
        </Typography>
      )}

      <div style={{ height }}>
        <ResponsivePie
          data={dataPoints}
          margin={{ top: 30, right: 30, bottom: 30, left: 30 }}
          colors={{ scheme: 'category10' }}
        />
      </div>
    </section>
  )
}
